import {connect} from "react-redux";
import AMVisit from "./visit";
import {bindActionCreators} from "redux";
import {getFse} from "../../../../service/FasttagToll/action";
import {markAttendance, isCheckout, tollById, fseOtp, activitySave} from "../../../../service/FasttagToll/action";
import {accountDetailsById} from "../../../../service/Account/action";
import {documentUploadUrlPublic} from "../../../../service/fileUpload/action";
const mapStateToProps = (state) => ({
    fseDetails:state.FasttagToll.fseDetails,
    accountDetails:state.Dropdown.accountDetailsById,
    isCheckoutDetails:state.FasttagToll.isCheckout,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    attendance:state.FasttagToll.attendance,
    tollView:state.FasttagToll.tollView,
    fseOTPResponse:state.FasttagToll.fseOTPResponse,
    saveActivityResponse:state.FasttagToll.saveActivityResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getFse,
            markAttendance,
            accountDetailsById,
            isCheckout,
            documentUploadUrlPublic,
            tollById,
            fseOtp,
            activitySave
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(AMVisit);
